module.exports = __webpack_public_path__ + "static/media/happy.43e1f6e8.svg";